import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

type Health = {
  ok: boolean;
  service: string;
  version: string;
  uptime: number;
  now: string;
};

export default function Dashboard() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['health'],
    queryFn: () => api<Health>('/api/health'),
    refetchInterval: 30_000,
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Přehled</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Vítej. Aplikace se rozjíždí — funkce přibývají podle plánu.
        </p>
      </div>

      <section className="rounded-lg border p-4">
        <h2 className="text-sm font-medium text-muted-foreground">Stav serveru</h2>
        {isLoading && <p className="text-sm mt-2">Načítám…</p>}
        {error && (
          <p className="text-sm mt-2 text-destructive">Server neodpovídá: {String(error)}</p>
        )}
        {data && (
          <dl className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm mt-2">
            <dt className="text-muted-foreground">Služba</dt>
            <dd>{data.service}</dd>
            <dt className="text-muted-foreground">Verze</dt>
            <dd>{data.version}</dd>
            <dt className="text-muted-foreground">Běží</dt>
            <dd>{Math.round(data.uptime)} s</dd>
            <dt className="text-muted-foreground">Čas serveru</dt>
            <dd>{new Date(data.now).toLocaleString('cs-CZ')}</dd>
          </dl>
        )}
      </section>

      <section className="rounded-lg border p-4 bg-muted/30">
        <h2 className="text-sm font-medium">Co je hotovo</h2>
        <ul className="text-sm mt-2 space-y-1 list-disc list-inside text-muted-foreground">
          <li>Backend (Express + SQLite + Drizzle) běží na portu 3040</li>
          <li>Databázové schéma: nemovitosti, vlastníci, kontakty, šablony, kampaně, dopisy</li>
          <li>Frontend (React + Vite + Tailwind) — kostra navigace</li>
        </ul>
        <h2 className="text-sm font-medium mt-4">Co bude dál</h2>
        <ul className="text-sm mt-2 space-y-1 list-disc list-inside text-muted-foreground">
          <li>Přihlašování (better-auth)</li>
          <li>Nahrávání katastru + parser + review obrazovka</li>
          <li>CRUD nemovitostí a vlastníků s filtry</li>
          <li>Editor šablon, generace PDF, tisková fronta</li>
          <li>Definice kampaní + plánovač (cron)</li>
        </ul>
      </section>
    </div>
  );
}
